import { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage } from './popups'
import { scrollTo, responsiveTables, stickyOnScroll, breadcrumbs, changeLogo } from './misc';
import setScrollBarWidth from 'set-scrollbar-width';  // Use with the Tailwind Container Break Out extension.
import scrollAnimations from './scrollAnimations'
import masonry from './masonry';
import contact from './contact';
import profiles from './profiles';

/* Blocks */
import accordion from '../../templates/blocks/accordion';
import videoPlayButton from '../../templates/blocks/video/video';
import imageGallery from '../../templates/blocks/image-gallery/image-gallery';
import newsSlider from '../../templates/blocks/news-slider/news-slider';
import verticalTextSlider from "../../templates/blocks/vertical-text-slider/vertical-text-slider";
import testimonialsSlider from "../../templates/blocks/testimonials-slider/testimonials-slider";
import newsAndEvents from "../../templates/blocks/news-and-events/news-and-events";
import typedText from "../../templates/blocks/typed-text/typed-text";
import ctaAndText from "../../templates/blocks/cta-and-text/cta-and-text";


/* Parts */
import marquee from "./marquee";
import whereNextSwitcher from '../../templates/sections/where-next/where-next';
import bannerHome from '../../templates/sections/banner/banner--home';
import bannerSubject from '../../templates/sections/banner/banner--subject';

// Nav
import mainMenu from '../../templates/parts/top-nav/nav'

function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}



/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function() {
	// Init
	consoleMessage()
	usingJS()
	setScrollBarWidth()
	scrollTo()
	stickyOnScroll()
	responsiveTables()
	//breadcrumbs()
	changeLogo()
	scrollAnimations()
	masonry()
	contact()
	profiles()

    // Nav
    mainMenu()

	// Popups
	magnificPopupIframe()
	magnificPopupInline()
	magnificPopupSingleImage()
	magnificPopupGalleryImage()

	// Blocks
	accordion()
    videoPlayButton()
    imageGallery()
    newsSlider()
	verticalTextSlider()
	testimonialsSlider()
	newsAndEvents()
	typedText()
	ctaAndText()

    // Parts
	marquee()
    whereNextSwitcher()
	bannerHome()
	bannerSubject()
}

// On window resize
window.addEventListener('resize', function(event) {
	videoPlayButton()
	changeLogo()
	bannerHome()
	contact()
})



jQuery(document).ready(function ($) {
	ajax: {
		/**
		 * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
		 */
		$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
			magnificPopupIframe()
			magnificPopupInline()
			magnificPopupSingleImage()
			magnificPopupGalleryImage()
			accordion()
		});
	}

	externallinks: {
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
});


